import HelperPlatform from 'utils/helper-platform'
import _ from 'lodash'

export const filterTabs = ( tabs, settings ) => {
	let isWeb = HelperPlatform.isWeb();
	let isPad = HelperPlatform.isIpad();
	let isPhone = isWeb === false && isPad === false;
	
	return _.filter( tabs, tab => {
		if( isWeb && !tab.webCompatible ) {
			return false;
		}
		
		if( isPad && !tab.padCompatible ) {
			return false;
		}
		
		if( isPhone && !tab.phoneCompatible ) {
			return false;
		}
		
		return true;
	});
}
